// =====================================================
// Payment Mode Utility
// 결제 모드 (mock/real) 관리 유틸리티
// =====================================================

/**
 * 결제 모드 타입
 * - mock: PG 없이 로컬 테스트 (기본값)
 * - real: 실제 PG 연동 (아임포트/토스페이먼츠 등)
 */
export type PaymentMode = 'mock' | 'real';

/**
 * 현재 결제 모드 반환
 * @returns 'mock' | 'real'
 */
export const getPaymentMode = (): PaymentMode => {
  const mode = import.meta.env.VITE_PAYMENT_MODE as PaymentMode;

  // 기본값은 mock
  if (mode !== 'mock' && mode !== 'real') {
    console.warn(
      `⚠️ VITE_PAYMENT_MODE가 유효하지 않습니다: "${mode}". 기본값 'mock'을 사용합니다.`
    );
    return 'mock';
  }

  return mode;
};

/**
 * Mock 모드인지 확인
 * @returns true if mock mode
 */
export const isPaymentMockMode = (): boolean => {
  return getPaymentMode() === 'mock';
};

/**
 * Real 모드인지 확인
 * @returns true if real mode
 */
export const isPaymentRealMode = (): boolean => {
  return getPaymentMode() === 'real';
};

/**
 * 결제 모드 로그 출력 (디버깅용)
 */
export const logPaymentMode = (): void => {
  const mode = getPaymentMode();
  const emoji = mode === 'mock' ? '🧪' : '💳';
  console.log(`${emoji} 결제 모드: ${mode}`);
};
